import styled from '@emotion/styled';

interface AppContainerProps {
  children: React.ReactNode;
}

export const AppContainer = styled.div<AppContainerProps>``;
